import { createSlice } from "@reduxjs/toolkit";
import { AR_CONTENT_TAB, GROUP_TAB_TYPE, RESOURCE_APPLICATION_TAB, RESOURCE_ENVIRONMENT_TAB, RESOURCE_MODULE_TAB, RESOURCE_SKILL_SCHOOL_TAB, RESOURCE_SKILL_STREAM_TAB, USER_TAB_TYPE } from "../../constant/constants";

const initialCount = {
    [RESOURCE_APPLICATION_TAB]: 0,
    [RESOURCE_MODULE_TAB]: 0,
    [RESOURCE_ENVIRONMENT_TAB]: 0,
    [RESOURCE_SKILL_STREAM_TAB]: 0,
    [RESOURCE_SKILL_SCHOOL_TAB]: 0,
    [AR_CONTENT_TAB]: 0,
    [GROUP_TAB_TYPE]: 0,
    [USER_TAB_TYPE]: 0,
}

const initialFilter = {
    [RESOURCE_APPLICATION_TAB]: {},
    [RESOURCE_MODULE_TAB]: {},
    [RESOURCE_ENVIRONMENT_TAB]: {},
    [RESOURCE_SKILL_STREAM_TAB]: {},
    [RESOURCE_SKILL_SCHOOL_TAB]: {},
    [AR_CONTENT_TAB]: {},
    "CATEGORY_TAB_FILTER": {}
}

const initialState = {
    filter: { ...initialFilter },
    total: { ...initialCount }
}

const filterOptions = createSlice({
    name: "filterOptions",
    initialState,
    reducers: {
        saveTotalCount: (state, action) => {
            state.total = { ...state.total, ...action.payload.data }
        },
        resetTotalCount: (state, action) => {
            state.total = { ...initialCount }
        },
        saveFilter: (state, action) => {
            state.filter = { ...state.filter, ...action.payload.data }
        },
    },

});

export const { saveTotalCount, saveFilter, resetTotalCount } = filterOptions.actions;
export default filterOptions.reducer;